import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import common from './assets/js/common.js'

import 'lib-flexible/flexible.js'

// 引入 图片浏览插件
import vuePicturePreview from 'vue-picture-preview'
Vue.use(vuePicturePreview)
// 引入 提示框插件
import Toast from 'vue-toast-cpn'
Vue.use(Toast)
// 引入 上拉加载下拉刷新
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

// 引入请求
import http from './assets/js/request'
Vue.prototype.$http = http

// 引入 滚动swiper
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

// 引入 loading组件
import Loading from './components/loading/loading'
Vue.use(Loading)

// // 引入 pop组件
import Popdefult from './components/pop/popdefult'
Vue.use(Popdefult)

// // 引入 pop组件
import UserAgreement from './components/userAgreement/userAgreement'
Vue.use(UserAgreement)

// 引入vant
import { Popup, Dialog } from 'vant';
Vue.use(Popup).use(Dialog);


import './assets/styles/fonts.css'


Vue.config.productionTip = false


// 全局检测
router.beforeEach((to, from, next) => {
  if(to.path == '/guide' || to.path == '/share') {
    next();
  }else {
    next();
    common.checkClientLogin().then((res) => {
      
    }).catch((err) => {
      Dialog.alert({
        message: '钱大师助手链接失败！'
      }).then((res) => {
        router.replace('/guide');
      })
    });
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')